import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import SUCCESS from "../../../assets/images/SUCCESS.svg";
import Text from "../../atoms/Text/Text";
import Title from "../../atoms/Title/Title";
import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/Header/Header";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import { useDispatch } from "react-redux";
import { persistedStore } from "../../../rtk/_config/store";
import { config as appConfig } from "../../../config";
import { resetBasket } from "../../../rtk/basket/basket";
import { isAppSource } from "../../../helpers/getSourceFromUrl";

const Success = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const ReturnToTheApp = async () => {

    await dispatch(resetBasket());
    await persistedStore.flush();

    if(isAppSource()) {
      window.location.href = 'weenect://app/home'
    } else {
      window.location.href = appConfig.REACT_APP_FE_BASE_URL;
    }
  };

  return (
    <>
      <Header headerStep={{ context: "new_subscription", step: 4, totalSteps: 3 }}title={t("subscription:SUCCESS_PAGE.TITLE")} />
      <Box className="Success">
        <Box className="content">
          <LogoSvg className="Logos" src={SUCCESS} />
          <Title variant="h1" children={t("subscription:SUCCESS_PAGE.TITLE") + " !"}/>
          <Text children={t("subscription:SUCCESS_PAGE.TEXT")} />
        </Box>
      </Box>
      <Footer headerStep={{ context: "new_subscription", step: 1, totalSteps: 3 }}>
        <StyledButton
          children={t("subscription:FIRST_PAGE.BUTTON")}
          onClick={() => ReturnToTheApp()}
        />
      </Footer>
    </>
  );
};

export default Success;
